import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getHomeSectionInitActions(responseData) {
  const isMobile =
    responseData.session.device && responseData.session.device.isMobile;
  const commentMaxDepth = isMobile ? 2 : 4;
  const params = { commentMaxDepth };
  return [
    getSectionLayoutInitAction(responseData, 'home'),
    ...getAllModulesInitActions(responseData, params),
  ].filter(action => action);
}
